import * as React from 'react';
import { ConfigContext } from '../config-provider';
const Empty = () => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('empty-img-default');
    return (<div className={prefixCls}/>
    // <svg
    //   className={prefixCls}
    //   width="80"
    //   height="80"
    //   xmlns="http://www.w3.org/2000/svg"
    //   xmlnsXlink="http://www.w3.org/1999/xlink"
    // >
    //   <defs>
    //     <linearGradient x1="81.337%" y1="100%" x2="21.679%" y2="-4.561%" id="e">
    //       <stop stopColor="#EAF6FF" offset="0%" />
    //       <stop stopColor="#9EC8FF" offset="100%" />
    //     </linearGradient>
    //     <linearGradient x1="81.337%" y1="100%" x2="18.663%" y2="0%" id="f">
    //       <stop stopColor="#E4F7FB" offset="0%" />
    //       <stop stopColor="#ADD3DC" offset="100%" />
    //     </linearGradient>
    //     <filter
    //       x="-16.8%"
    //       y="-13.7%"
    //       width="133.6%"
    //       height="127.3%"
    //       filterUnits="objectBoundingBox"
    //       id="a"
    //     >
    //       <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
    //       <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
    //       <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" in="shadowBlurOuter1" />
    //     </filter>
    //     <filter
    //       x="-16.3%"
    //       y="-12.9%"
    //       width="132.6%"
    //       height="125.8%"
    //       filterUnits="objectBoundingBox"
    //       id="c"
    //     >
    //       <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
    //       <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
    //       <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" in="shadowBlurOuter1" />
    //     </filter>
    //     <path
    //       d="m7.38 9.485 31.317-.156a2.074 2.074 0 0 1 2.084 2.084l-.194 39.526a2.074 2.074 0 0 1-2.064 2.064l-31.317.156a2.074 2.074 0 0 1-2.084-2.084l.194-39.526A2.074 2.074 0 0 1 7.38 9.485z"
    //       id="b"
    //     />
    //     <path
    //       d="m10.79 19.558 32.279.231a2.074 2.074 0 0 1 2.059 2.06l.297 42.015a2.074 2.074 0 0 1-2.089 2.088l-32.278-.231a2.074 2.074 0 0 1-2.059-2.06l-.297-42.015a2.074 2.074 0 0 1 2.089-2.088z"
    //       id="d"
    //     />
    //   </defs>
    //   <g fill="none" fillRule="evenodd">
    //     <path
    //       d="M20.67 8.937 51.94 4.454a1.92 1.92 0 0 1 2.175 1.639l5.442 39.501a1.92 1.92 0 0 1-1.63 2.163l-31.27 4.483a1.92 1.92 0 0 1-2.175-1.639L19.04 11.1a1.92 1.92 0 0 1 1.63-2.163z"
    //       fill="#E6F7FA"
    //     />
    //     <g transform="rotate(-15 44.643 -16.128)">
    //       <use fill="#000" filter="url(#a)" xlinkHref="#b" />
    //       <use fill="#FFF" xlinkHref="#b" />
    //     </g>
    //     <g fillRule="nonzero" transform="rotate(23 23.733 76.704)">
    //       <use fill="#000" filter="url(#c)" xlinkHref="#d" />
    //       <use fill="url(#e)" xlinkHref="#d" />
    //       <use fill="url(#f)" xlinkHref="#d" />
    //     </g>
    //     <g transform="rotate(23 -74.865 107.727)" fill="#FFF">
    //       <rect width="14.118" height="1.731" rx=".866" />
    //       <path
    //         d="M.866 6.12h9.562a.866.866 0 0 1 0 1.731H.866a.866.866 0 0 1 0-1.731z"
    //         fillOpacity=".6"
    //       />
    //       <rect opacity=".4" y="12.24" width="14.118" height="1.731" rx=".866" />
    //     </g>
    //   </g>
    // </svg>
    );
};
export default Empty;
